import axios from 'axios';
import {GET_DATA, DATA_ERROR} from '../types';

export const getData = (email) => async (dispatch) => {
  try {
    const res = await axios.get('/rippleData', {
      params: {
        email,
      },
    });
    dispatch({
      type: GET_DATA,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: DATA_ERROR,
      payload: error,
    });
  }
};
